"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M2.214 1h19.572C22.456 1 23 1.543 23 2.214v19.572c0 .67-.543 1.214-1.214 1.214h-5.613v-8.508h2.871v-.004h.019l.428-3.33h-3.3v-2.12c0-.8.186-1.385 1.038-1.561a3.08 3.08 0 01.594-.051h1.763V4.452a24.37 24.37 0 00-2.56-.13c-2.297 0-3.932 1.269-4.221 3.617a6.29 6.29 0 00-.046.772v2.45H9.895v3.331h2.864V23H2.214C1.544 23 1 22.457 1 21.786V2.214C1 1.544 1.543 1 2.214 1z" }), "Facebook");
//# sourceMappingURL=Facebook.js.map